<template>
  <div class="transaction-summary">
    <v-row v-if="membershipType">
      <v-col lg="12" md="12" cols="12">
        <WarningAlert v-if="transactionSummary.total > 0">
          <p style="margin-bottom:0;">
            {{ itemOrg.paymentPlatform && itemOrg.paymentPlatform.toLowerCase() == 'paypal' ? $tc("memberRegistration.step6.content.alert_line_1") : "" }}
          </p>
          <p>{{ $t("memberRegistration.step6.content.alert_line_2") }}</p>
        </WarningAlert>
        <v-card
          class="mx-auto"
        >
          <v-card-text>
            <v-banner :color="buttonColor" rounded
              >{{ itemOrg.orgName }}
              {{
                $t("memberRegistration.step6.content.transaction_summary")
              }}</v-banner
            >
            <v-card v-if="loading" :loading="loading" class="hide-content"
              ><v-card-text></v-card-text
            ></v-card>

            <v-data-table
              :headers="headers"
              :items="transactionSummary.rows"
              :items-per-page="-1"
              class="elevation-2"
              :footer-props="{
                'items-per-page-text': $t('dataTable.rowsPerPageText'),
                'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
              }"
              :no-data-text="$t('dataTable.noDataText')"
              :headerProps="{
                'sort-by-text': $t('dataTable.sortByText')
              }"
            >
              <template v-slot:item.roundedPrice="{ item }">
                <!-- Add the prefix to the item value in the column -->
                <span>{{ "$" + item.roundedPrice }}</span>
              </template>

              <template v-slot:item.taxed="{ item }">
                <!-- Add the prefix to the item value in the column -->
                <span>{{
                  $t("memberRegistration.step6.content.".concat(item.taxed))
                }}</span>
              </template>

              <template v-slot:item.name="{ item }">
                <!-- Add the prefix to the item value in the column -->
                <span>{{
                  item.name == "membership_type"
                    ? $t(
                        "memberRegistration.step6.content.".concat(item.name)
                      )
                    : item.name
                }}</span>
              </template>

              <template v-slot:item.details="{ item }">
                <!-- Add the prefix to the item value in the column -->
                <span v-html="item.details == 'membership' ? $t('memberRegistration.step6.content.' + item.details) : item.details"></span>
              </template>

              <template v-slot:footer>
                <v-container class="grey lighten-5">
                  <v-row no-gutters>
                    <v-col md="7"> </v-col>
                    <v-col md="2" class="resume text-start">
                      {{ $t("memberRegistration.step6.content.sub_total") }}:
                    </v-col>
                    <v-col md="3" class="resume text-end">
                      ${{ transactionSummary.roundedSubtotal }}
                    </v-col>
                  </v-row>
                  <v-row
                    no-gutters
                    v-for="(item, index) in transactionSummary.taxes"
                    :key="index"
                  >
                    <v-col md="7"> </v-col>
                    <v-col md="2" class="resume text-start">
                      {{ $t("memberRegistration.step6.content.tax") }}
                      {{ item.taxLabel }} ({{ item.taxNumber }})
                    </v-col>
                    <v-col md="3" class="resume text-end">
                      ${{ item.roundedTaxAmount }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col md="7"> </v-col>
                    <v-col md="2" class="resume text-start">
                      {{ $t("memberRegistration.step6.content.total") }} ({{ membershipType.currency.toUpperCase() }}):
                    </v-col>
                    <v-col md="3" class="resume text-end">
                      ${{ transactionSummary.roundedTotal }}
                    </v-col>
                  </v-row>
                </v-container>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
      <div class="text-center mb-6 mt-4" v-if="membershipType">
        <v-btn v-if="transactionSummary.total > 0"
            color="#a45151"
            class="ma-2 btn_next"
            @click="cancelRegistration"
            >{{ $t("memberRegistration.step6.content.cancel_registration") }}</v-btn>

            <v-btn
            v-if="membershipType && transactionSummary.total > 0"
            :color="`${buttonColor}`"
            style="margin-left: 20px;"
            class="ma-2 btn_next"
            :disabled="disabledButton"
            @click="doPayment"
            >
            <v-progress-circular 
                size="10"
                v-if="isLoading"
                indeterminate
                color="white"
                class="mr-2"
                ></v-progress-circular>
            {{ $t("memberRegistration.step6.content.proceed_to_payment") }}</v-btn>
            
      </div>
      <div class="text-end mb-6 mt-4" v-if="membershipType">
        <v-btn
          v-if="membershipType && transactionSummary.total == 0"
          :disabled="membershipType && transactionSummary.total > 0"
          :color="`${buttonColor}`"
          @click="setMembershipCardsStep"
          class="ma-2 btn_next"
          style="margin-left: 20px;"
          >{{ $t("registerEvent.next") }}</v-btn>
      </div>
    <v-row >
    </v-row>
  </div>
</template>

<script>
import WarningAlert from "@/components/alert/WarningAlert";
import {
  VRow,
  VCol,
  VBtn,
  VCard,
  VCardText,
  VDataTable,
  VContainer,
  VBanner,
  VProgressCircular
} from "vuetify/lib";
export default {
  components: {
    WarningAlert,
    VRow,
    VCol,
    VBtn,
    VCard,
    VCardText,
    VDataTable,
    VContainer,
    VBanner,
    VProgressCircular
  },
  props: {
    step: Number,
    buttonColor: String,
    membershipType: Object,
    itemOrg: Object,
    selectedParticipants: Array,
  },
  data() {
    return {
      loading: true,
      transactionSummary: [],
      disabledButton: false,
      isLoading:false
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("memberRegistration.step6.content.name"),
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: this.$t("memberRegistration.step6.content.details"),
          align: "start",
          sortable: false,
          value: "details",
        },
        {
          text: this.$t("memberRegistration.step6.content.number"),
          align: "start",
          sortable: false,
          value: "number",
        },
        {
          text: this.$t("memberRegistration.step6.content.taxed"),
          align: "start",
          sortable: false,
          value: "taxed",
        },
        {
          text: this.$t("memberRegistration.step6.content.price"),
          align: "start",
          sortable: false,
          value: "roundedPrice",
        },
      ];
    },
    prevStep() {
      return this.step - 1;
    },
    nextStep() {
      return this.step + 1;
    },
    isTaxable() {
      return this.membershipType.taxable == 1 ? "Yes" : "No";
    },
  },

  methods: {
    Initialize(data) {
      this.transactionSummary = data;
      this.loading = false;
    },
    doPayment()
    {
      this.disabledButton = true
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
        this.disabledButton = false
      }, 10000);
      this.$emit("paypalPayment", this.transactionSummary.regid);
    },
    cancelRegistration() {
      this.$emit("cancelRegistration", this.transactionSummary.token);
    },
    setMembershipCardsStep()
    {
      this.$emit("setMembershipCardsStep", this.transactionSummary.token);
    }
  },
};
</script>

<style>
#memberRegistration .transaction-summary .v-banner__text {
  color: white !important;
}
.resume {
  background-color: lightgray !important;
  padding: 10px 15px !important;
}
</style>
